import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import CommitPlaceholder from './placeholders/CommitPlaceholder';
import MostCommonIssueDashboardPlaceholder from './placeholders/MostCommonIssueDashboardPlaceholder';
import MostCommonIssuePlaceholder from './placeholders/MostCommonIssuePlaceholder';
import PullRequestPlaceholder from './placeholders/PullRequestPlaceholder';
import RepositoryActivePlaceholder from './placeholders/RepositoryActivePlaceholder';
import RepositoryPlaceholder from './placeholders/RepositoryPlaceholder';
class LoadingPlaceholder extends Component {
    render() {
        const { type, count } = this.props;
        const template = [];
        for (let i = 0; i < count; i++) {
            if (type === 'commit') {
                template.push(_jsx(CommitPlaceholder, {}, i));
            }
            else if (type === 'pullRequest') {
                template.push(_jsx(PullRequestPlaceholder, {}, i));
            }
            else if (type === 'mostCommonIssueDashboard') {
                template.push(_jsx(MostCommonIssueDashboardPlaceholder, {}, i));
            }
            else if (type === 'mostCommonIssue') {
                template.push(_jsx(MostCommonIssuePlaceholder, {}, i));
            }
            else if (type === 'repository') {
                template.push(_jsx(RepositoryPlaceholder, {}, i));
            }
            else if (type === 'activeRepository') {
                template.push(_jsx(RepositoryActivePlaceholder, {}, i));
            }
            else {
                throw new Error(`Unknown type ${type}`);
            }
        }
        return template;
    }
}
LoadingPlaceholder.defaultProps = {
    type: 'commit',
    count: 3,
};
export default LoadingPlaceholder;
